import React from "react";
import styled from "styled-components";
import "./login.css";
import Image from "next/image";
import "../../Components/IPWebsiteRedesign/Research.css";

const Title = styled.div`
  font-size: 22px;
  font-family: "Roboto";
  font-weight: 600;
  line-height: 42px;
  color: #15436d;
  text-align: center;

  @media screen and (max-width: 767px) {
    line-height: 28px;
    font-size: 18px;
  }
`;
const Desc = styled.div`
  text-align: center;
  font-size: 16px;
  font-family: "Roboto";
  line-height: 28px;
  color: #454545;
  width: 535px;
  margin: 0 auto;
  text-align: center;
  margin-top: 10px;

  @media screen and (max-width: 767px) {
    width: auto;
    line-height: 25px;
    font-size: 14px;
  }
`;
const ImgT = styled.div`
  /* width: 490px;
  margin: 0 auto;
  display: flex; */

  width: 400px;
  height: auto;
  margin: 0 auto;
  display: flex;
  /* border: 1px solid; */

  @media screen and (max-width: 767px) {
    width: 300px;
  }
`;

const MobileWrapper = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block; /* Visible on mobile devices */
  }
`;

const DesktopWrapper = styled.div`
  display: none;

  @media (min-width: 769px) {
    display: block; /* Visible on desktop devices */
  }
`;

const StyledImage = styled(Image)`
  width: 450px;
  height: auto;

  @media screen and (max-width: 1366px) {
    width: 335px;
    height: auto;
  }

  @media screen and (max-width: 1280px) {
    width: 335px;
    height: auto;
  }
`;

export default function LoginTempSlider(props) {
  return (
    <div>
      <div className="ip-temp-wrap">
        {/* <ImgT>
            <Image
              className={
                props.image1
                  ? "mob-img-fix des-fix-img1"
                  : "mob-img-fix des-fix-img"
              }
              src={props.Temp}
              alt={props.heading}
              priority={true}
            />
          </ImgT> */}
        <DesktopWrapper>
          <ImgT>
            <StyledImage
              src={props.Temp}
              alt={props.heading}
              priority={true}
            //   style={{
            //     width: "400px",
            //     height: "auto",
            //   }}
            />
          </ImgT>
        </DesktopWrapper>

        <MobileWrapper>
          <ImgT>
            <Image
              src={props.Temp}
              alt={props.heading}
              priority={true}
              style={{
                width: "300px",
                height: "auto",
              }}
            />
          </ImgT>
        </MobileWrapper>

        <div>
          <Title>{props.title}</Title>
        </div>
        <div>
          <Desc>{props.desc}</Desc>
        </div>
      </div>
    </div>
  );
}
